import moment from 'moment';
import get from 'lodash/get';

import { LinkToIvr } from './ivrLogsLayout';

export const transformDateToString = value => moment.utc(value).local().format('MM/DD/YYYY HH:mm:ss');

export const linkToIvrRenderer = row =>
  LinkToIvr({
    id: get(row, 'event.ivrId'),
    name: get(row, 'ivrName'),
    nodeId: get(row, 'event.ivrNodeId'),
    version: get(row, 'event.ivrVersion'),
  });
